import constants from '../lib/constants'
import * as _ from 'lodash'
import axios from 'axios'
import cmp from 'semver-compare'

// Constants
// ------------------------------------

const GET_ALL_VERSIONS = 'GET_ALL_VERSIONS'
const UPDATE_PINNED_VERSION = 'UPDATE_PINNED_VERSION'
const UPDATE_ROLLOUT = 'UPDATE_ROLLOUT'
const UPDATE_ROLLBACK = 'UPDATE_ROLLBACK'
const GET_VERSION_STATUS = 'GET_VERSION_STATUS'

// Actions
// ------------------------------------
export const getAvailableVersions = (deploymentState = 'staging') => {
  return (dispatch, getState) => {
    return axios.get(
      `${constants.API_URL}/ota/get_available_versions`,
      {
        params: {
          deployment_state: deploymentState
        }
      }
    )
    .then((response) => {
      const sortedVersions = response.data.versions.sort((a, b) => -cmp(a, b))
      dispatch({
        type    : GET_ALL_VERSIONS,
        payload : {
          deploymentState,
          versions: sortedVersions,
          pinnedVersions: response.data.pinned_versions
        }
      })
      return response
    })
  }
}

export const pinVersion = (pinnedVersion, deploymentState) => {
  return (dispatch, getState) => {
    return axios.post(
      `${constants.API_URL}/ota/set_pinned_version`,
      {
        pinned_version: pinnedVersion,
        deployment_state: deploymentState
      }
    )
    .then((response) => {
      dispatch({
        type: UPDATE_PINNED_VERSION,
        payload: {
          deploymentState,
          pinnedVersions: response.data.pinned_versions
        }
      })
    })
  }
}

export const rolloutVersion = (version, percentage, deploymentState, holdback) => {
  return (dispatch, getState) => {
    return axios.post(
      `${constants.API_URL}/ota/rollout`,
      {
        version: version,
        percentage: percentage,
        deployment_state: deploymentState,
        holdback: holdback
      }
    )
    .then((response) => {
      dispatch({
        type: UPDATE_ROLLOUT,
        payload:{
          version: version
        }
      })
    })
  }
}

export const rollbackVersion = (currentVersion, targetVersion, deploymentState) => {
  return (dispatch, getState) => {
    return axios.post(
      `${constants.API_URL}/ota/rollback`,
      {
        current_version: currentVersion,
        target_version : targetVersion,
        deployment_state: deploymentState,
      }
    )
    .then((response) => {
      dispatch({
        type: UPDATE_ROLLBACK,
        payload:{
          version: targetVersion
        }
      })
    })
  }
}

export const versionStatus = (deploymentState) => {
  return (dispatch, getState) => {
    return axios.get(
      `${constants.API_URL}/ota/version_status`,
      {
        params: {
          deployment_state: deploymentState
        }
      }
    )
    .then((response) => {
      console.log(response.data.patients)
      dispatch({
        type    : GET_VERSION_STATUS,
        payload : {
          deploymentState,
          status: response.data,
        }
      })
      return response
    })
  }
}

export const actions = {
  getAvailableVersions
}

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [GET_ALL_VERSIONS] : (state, action) => {
    const { deploymentState, versions, pinnedVersions } = action.payload
    const newState = {
      ...state,
      [deploymentState]: {
        versions,
        pinnedVersions
      }
    }
    return newState
  },
  [UPDATE_PINNED_VERSION]: (state, action) => {
    const { deploymentState, pinnedVersions } = action.payload
    const newState = {
      ...state,
      [deploymentState]: {
        versions: state[deploymentState].versions,
        pinnedVersions
      }
    }
    return newState
  },
  [GET_VERSION_STATUS]: (state, action) => {
    const { deploymentState, status } = action.payload
    const newState = _.merge({}, state, {
      [deploymentState]: {
        status: status
      }
    })
    return newState
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  staging: {
    versions: [],
    pinnedVersions: []
  },
  production: {
    versions: [],
    pinnedVersions: []
  }
}

export default function qcReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/versions.js